import styled from "styled-components"
import {Button, device, IconSvg} from "monica-alexandria"

const SidebarSocial = styled.div``

const SidebarSocialMeta = styled.div``

const SidebarSocialMetaConnected = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    padding: .5rem;
    padding-left: ${p => p.sidebar ? "4rem" : "1rem"};
    cursor: pointer;

    svg{
        width: var(--normalIcon);
        fill: var(--main);
        display: none;
    }

    &:hover{
        background: ${p => p.theme.low};

        svg{
            display: block;
        }
    }

    @media ${device.sm} {
        padding-left: 2rem;

        svg{
            display: ${p => p.sidebar ? "block" : "none"};
            margin-right: 1rem;
        }
    }
`

const SidebarSocialMetaConnectedLeft = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;

    img{
        width: 3rem;
        height: 3rem;
        overflow: hidden;
        border-radius: 50%;
        object-fit: cover;
    }

    h5{
        display: ${p => p.sidebar ? "block" : "none"};
    }

    @media ${device.sm} {
        h5{
            display: ${p => p.sidebar ? "block" : "none"};
        }

        img{
            width: 3.5rem;
            height: 3.5rem;
        }
    }
`

const SidebarSocialConnect = styled(Button)`
    background: transparent;
    border-radius: var(--normalRadius);
    border: 2px solid ${p => p.theme.mid};
    margin-left: ${p => p.sidebar ? "4rem" : "1rem"};

    span{
        color: var(--greyDark);
    }

    svg{
        fill: var(--greyDark);
    }

    @media ${device.sm} {
        margin-left: 2rem;
        padding: .8rem;

        span{
            display: ${p => p.sidebar ? "block" : "none"};
        }
    }
`

const SidebarSocialSep = styled.div`
    margin: 1rem 4rem;
    height: 2px;
    width: calc(100% - 8rem);
    background: ${p => p.theme.low};

    @media ${device.sm} {
        width: calc(100% - 4rem);
        margin: 1rem 2rem;
    }
`

export const Sidebar_Social = (props) => {
  return (
    <SidebarSocial>
        <h6>{props.socialTitle}</h6>
        {props.socialMeta ?
            <SidebarSocialMeta>
                <SidebarSocialMetaConnected sidebar={props.sidebar}>
                    <SidebarSocialMetaConnectedLeft sidebar={props.sidebar}>
                        <img src={props.metaImg} />
                        <h5>{props.metaProfile}</h5>
                    </SidebarSocialMetaConnectedLeft>
                    <IconSvg Icon="Swap" />
                </SidebarSocialMetaConnected>
            </SidebarSocialMeta>
        :
            <SidebarSocialConnect onClick={props.onSocialConnect} sidebar={props.sidebar}>
                <IconSvg Icon="Add" />
                <span>{props.socialConnect}</span>
            </SidebarSocialConnect>    
        }
        <SidebarSocialSep></SidebarSocialSep>
    </SidebarSocial>
  )
}
